/**
 * Moss Matrix Routine Reward — customer-facing promise only.
 * Eligibility is tracked manually by checkout email + order history (no dashboard yet).
 * Do not track by IP. Do not auto-apply at checkout until fulfilment workflow exists.
 */

export const COMMUNITY_REWARD = {
  title: "Moss Matrix Routine Reward",
  shortTitle: "Routine Reward",
  headline: "Order 3 times. Get a free 300ml Gold jar.",
  homepageEyebrow: "Routine reward",
  offer:
    "Order on three separate occasions using the same checkout email. We’ll add a free plain 300ml Gold Sea Moss Gel to your next paid order.",
  tagline: "Keep it, share it, or pass it to someone who wants to try Moss Matrix properly.",
  homepageLead: "Order 3 times. Get a free 300ml Gold jar.",
  homepageTerms:
    "Order on three separate occasions using the same checkout email. We’ll add a free plain 300ml Gold Sea Moss Gel to your next paid order.",
  cartMessage: "Every paid order counts towards your 3-order reward.",
  cartTrackingNote: "Tracked by checkout email.",
  terms:
    "Tracked by checkout email. UK orders only. Free jar is plain 300ml Gold Sea Moss Gel. Added to a future paid order. One reward per customer.",
  /** For future admin / ops — not shown prominently on site */
  adminNote:
    "Future: count paid orders per checkout email in Supabase/order exports; flag at 3rd paid order; add free plain 300ml gold jar line on the following paid order. No IP tracking.",
};

export const COMMUNITY_REWARD_STEPS = [
  { n: 1, label: "1 / 3 orders" },
  { n: 2, label: "2 / 3 orders" },
  { n: 3, label: "3rd order unlocks your free jar", unlock: true },
];
